export default __webpack_public_path__ + "static/media/04_Business-Portrait-EschweilerPhotography_21A9969 (Kopie).abbf0a9d.jpg";